export { default as NewsInfo } from "./NewsInfo";
